import React, { useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { BadgeCheck, ArrowLeftCircle } from "lucide-react";
import Navbar from "../../components/Navbar";
import { SERVER_ROUTE, DEFAULT_ROUTE } from "../../routes/api/api_routes";
import { motion } from "framer-motion";

const levels = [
  { id: "Débutant", label: "DÉBUTANT", color: "bg-red-500", stars: 1 },
  {
    id: "intermediaire",
    label: "INTERMÉDIAIRE",
    color: "bg-orange-400",
    stars: 2,
  },
  { id: "Expert", label: "AVANCÉ", color: "bg-teal-600", stars: 3 },
];

const DifficultySelector = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const location = useLocation();
  const { quiz } = location.state || {};
  const { techId } = useParams();

  const handleClick = async (level) => {
    try {
      const token = localStorage.getItem("access");
      const response = await fetch(`${DEFAULT_ROUTE}start-quiz/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `JWT  ${token}`,
        },
        body: JSON.stringify({
          technology_id: techId,
          niveau: level,
          nombre_questions: 10,
        }),
      });

      if (!response.ok) {
        throw new Error("Erreur lors de la création du quiz");
      }

      const data = await response.json();
      navigate("/quizz/play", { state: { quiz: data } });
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white min-h-screen flex flex-col">
      <Navbar />
      <div className="relative flex-1 flex items-start md:items-center justify-center px-4 py-6 sm:py-12">
        <button
          onClick={() => navigate(-1)}
          className="absolute top-4 left-4 sm:top-6 sm:left-6 bg-teal-600 text-white hover:bg-teal-800 transition rounded-full z-10"
        >
          <ArrowLeftCircle size={32} />
        </button>

        {/* Fond animé */}
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
          className="bg-gradient-to-b from-[#003638] to-[#00b8a9] rounded-xl p-6 sm:p-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 w-full max-w-6xl justify-items-center"
        >
          {levels.map((level, index) => (
            <motion.div
              key={level.id}
              initial={{ opacity: 0, x: 100 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{
                duration: 0.6,
                delay: 0.5 + index * 0.2, // cascade
              }}
              className="bg-white/10 border border-white rounded-xl p-6 flex flex-col items-center w-full max-w-[300px] min-h-[340px]"
            >
              <h2 className="text-white text-lg font-bold mb-6 text-center">
                {level.label}
              </h2>

              <div
                className={`w-28 h-28 rounded-full flex items-center justify-center ${level.color} mb-6`}
              >
                <BadgeCheck className="text-white w-12 h-12" />
              </div>

              <button
                onClick={() => handleClick(level.id)}
                disabled={loading}
                className="bg-transparent border border-white text-white font-bold py-2 px-8 rounded-full hover:text-black hover:border-[#FFA000] transition"
              >
                {loading ? "Chargement..." : "GO !"}
              </button>

              {error && (
                <p className="text-red-400 mt-2 text-center">{error}</p>
              )}

              <div className="mt-6 flex gap-2">
                {Array(level.stars)
                  .fill()
                  .map((_, index) => (
                    <span key={index} className="text-white text-xl">
                      ★
                    </span>
                  ))}
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default DifficultySelector;
